/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */
import React, { useState, useRef, useEffect } from 'react';
import styles from '../../styles/components/controlVariations/Dropdown.module.css';
import arrowIcon from '../../assets/profile/Vector (13).png';

export interface MultiSelectDropdownProps {
    placeholder?: string;
    // options: string[];

    // selected: string[];
    // options: { label: string; value: string }[];
    options: {
        label: string;
        value: string;
        color?: string;
         disabled?: boolean;
    }[];
    selectedValues: string[];
    onChange: (values: string[]) => void;
    width?: string;
    height?: string | number;
    menuMaxHeight?: string | number;
    selectedLabel?: string;
    singleSelect?: boolean;
}

const MultiSelectDropdown: React.FC<MultiSelectDropdownProps> = ({
    placeholder = 'Select',
    options,
    selectedValues,
    onChange,
    width = '100%',
    height = '58px',
    menuMaxHeight = '240px',
    selectedLabel = 'Program',
    singleSelect = false,

}) => {
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () =>
            document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const toggleOption = (option: {
	label: string;
	value: string;
	color?: string;
	disabled?: boolean;
}) => {
	if (option.disabled) {
		return;
	}

	// If this option is already selected
	if (selectedValues.includes(option.value)) {
		// Unselect it
		onChange([]);
		return;
	}

	// Single-select mode:
	// remove previous selection and select only this option
	if (singleSelect) {
		onChange([option.value]);
		return;
	}

	// Normal multi-select mode
	onChange([...selectedValues, option.value]);
};

    
    
    const selectedLabels = options
        .filter(opt => selectedValues.includes(opt.value))
        .map(opt => opt.label);

    
    const displayText =
    selectedLabels.length > 0
        ? `${selectedLabels.length} ${selectedLabel}${
                selectedLabels.length > 1 ? 's' : ''
          } Selected`
        : placeholder;

    const norm = (v: string | number) => (typeof v === 'number' ? `${v}px` : v);

    return (
        <div
            className={styles.wrapper}
            style={{ width: norm(width) }}
            ref={ref}
        >
            <div
                className={`${styles.dropdown} ${open ? styles.active : ''}`}
                onClick={() => setOpen(!open)}
                style={{ height: norm(height) }}
            >
                <span className={styles.text}>{displayText}</span>
                <img
                    src={arrowIcon}
                    className={`${styles.icon} ${open ? styles.rotate : ''}`}
                    alt="toggle"
                />
            </div>

            {open && (
                <div
                    className={styles.menu}
                    style={{ maxHeight: norm(menuMaxHeight) }}
                >
                    {/* {options.map((opt, i) => (
                        <label key={i} className={styles.menuItem}>
                            <span>{opt}</span>
                            <input
                                type="checkbox"
                                checked={selected.includes(opt)}
                                onChange={() => toggleOption(opt)}
                            />
                        </label>
                    ))} */}
                    {/* {options.map(opt => (
                        <label key={opt.value} className={styles.menuItem}>
                            
                            <div className={styles.optionContent}>
                                <span
                                    className={styles.colorDot}
                                    style={{
                                        backgroundColor: opt.color,
                                    }}
                                />

                                <span>{opt.label}</span>
                            </div>
                            <input
                                type="checkbox"
                                checked={selectedValues.includes(opt.value)}
                                onChange={() => toggleOption(opt.value)}
                            />
                        </label>
                    ))} */}
                    {options.map(opt => (
    <label
        key={opt.value}
        className={`${styles.menuItem} ${
            opt.disabled ? styles.disabledItem : ''
        }`}
    >
        <div className={styles.optionContent}>
            <span
                className={styles.colorDot}
                style={{
                    backgroundColor: opt.color,
                }}
            />

            <span>{opt.label}</span>
        </div>

        <input
            type="checkbox"
            checked={selectedValues.includes(opt.value)}
            disabled={opt.disabled}
            onChange={() => toggleOption(opt)}
        />
    </label>
))}
                </div>
            )}
        </div>
    );
};

export default MultiSelectDropdown;
